import { StyleSheet } from 'react-native';

import { C } from 'common';
import { THEME, LAYOUT } from 'reactor/common';

const { LAYOUT: { ASIDE, WRAPPER } } = C;
const { SPACE } = THEME;

export default StyleSheet.create({
  aside: {
    paddingLeft: ASIDE.WIDTH + SPACE.L,
  },

  noAside: {
    margin: 'auto',
    width: '100%',
    maxWidth: WRAPPER.WIDTH,
  },

  container: {
    padding: SPACE.L,
    marginBottom: SPACE.XL,
    flex: 1,
  },

  containerPortrait: {
    padding: SPACE.MEDIUM,
    flex: 1,
  },

  content: {
    ...LAYOUT.STYLE.ROW,
    flexWrap: 'wrap',
    width: '100%',
  },

  wrapper: {
    alignSelf: 'center',
    maxWidth: WRAPPER.WIDTH,
  },
});
